export function getBaseURL() {
  if (window.APP_CONFIG && window.APP_CONFIG.BASE_URL) {
    return window.APP_CONFIG.BASE_URL;
  }
  return process.env.BASE_URL;
}

export function getHostURL() {
  if (window.APP_CONFIG && window.APP_CONFIG.HOST_URL) {
    return window.APP_CONFIG.HOST_URL;
  }
  return process.env.HOST_URL || '';
}



// WEBPACK FOOTER //
// ./src/utils/appConfig.js